
import React from 'react';
import { EventType } from '@/lib/types';
import FilterLocation from './FilterLocation';
import FilterDate from './FilterDate';
import FilterCreditPoints from './FilterCreditPoints';
import FilterProfessions from './FilterProfessions';
import FilterTypes from './FilterTypes';
import ActiveFilters from './ActiveFilters';

interface DesktopFilterContentProps {
  location: string;
  setLocation: (location: string) => void;
  selectedTypes: Record<EventType, boolean>;
  selectedProfessions: Record<string, boolean>;
  hasCreditPoints: boolean;
  dateRange: { startDate: string; endDate: string };
  currentDate?: Date;
  search: string;
  handleTypeClick: (type: EventType) => void;
  handleProfessionClick: (id: string) => void;
  toggleCreditPointsFilter: () => void;
  resetFilters: () => void;
  setDateRange: (dateRange: { startDate: string; endDate: string }) => void;
  hasActiveFilters: boolean;
}

const DesktopFilterContent: React.FC<DesktopFilterContentProps> = ({
  location,
  setLocation,
  selectedTypes,
  selectedProfessions,
  hasCreditPoints,
  dateRange,
  currentDate,
  search,
  handleTypeClick,
  handleProfessionClick,
  toggleCreditPointsFilter,
  resetFilters,
  setDateRange,
  hasActiveFilters
}) => {
  // Convert Record<EventType, boolean> to EventType[] for the components that expect arrays
  const selectedTypesArray = Object.entries(selectedTypes)
    .filter(([_, selected]) => selected)
    .map(([type]) => type as EventType);

  return (
    <div className="bg-medihub-cardBg transition-all">
      <div className="p-4 space-y-6">
        {/* Szűrők egymás alatt */}
        <FilterLocation location={location} onLocationChange={setLocation} />
        
        <FilterDate 
          dateRange={dateRange} 
          onDateChange={(newDateRange) => setDateRange(newDateRange)} 
          defaultMonth={currentDate} 
        />
        
        <FilterCreditPoints hasCreditPoints={hasCreditPoints} onToggle={toggleCreditPointsFilter} />
        
        <FilterProfessions 
          selectedProfessions={selectedProfessions} 
          onProfessionClick={handleProfessionClick} 
        />
        
        <FilterTypes 
          selectedTypes={selectedTypesArray} 
          onTypeClick={handleTypeClick} 
        />
        
        {/* Active filters */}
        {hasActiveFilters && (
          <div className="pt-4 border-t border-medihub-midPurple/10">
            <ActiveFilters 
              search={search} 
              location={location} 
              selectedTypes={selectedTypesArray} 
              hasCreditPoints={hasCreditPoints} 
              dateRange={dateRange} 
              onTypeClick={handleTypeClick}
              onLocationClear={() => setLocation('')} 
              onCreditPointsClear={() => toggleCreditPointsFilter()}
              onDateRangeClear={key => {
                const newDateRange = { ...dateRange };
                newDateRange[key as keyof typeof dateRange] = '';
                setDateRange(newDateRange);
              }} 
              onResetAll={resetFilters} 
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DesktopFilterContent;
